import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_FORNECEDOR_CADASTRO_SUCCESS,
    CANCEL_FORNECEDOR_CADASTRO_RAPIDO,
    CANCEL_FORNECEDOR_CADASTRO_RAPIDO_SUCCESS,
    TABLE_FORNECEDOR_CADASTRO_PENDING,
    TABLE_FORNECEDOR_CADASTRO_SUCCESS,
    TABLE_FORNECEDOR_CADASTRO_FAILURE,
    LIST_FORNECEDOR_CADASTRO_PENDING,
    LIST_FORNECEDOR_CADASTRO_SUCCESS,
    LIST_FORNECEDOR_CADASTRO_FAILURE,
    FIND_FORNECEDOR_CADASTRO_PENDING,
    FIND_FORNECEDOR_CADASTRO_SUCCESS,
    FIND_FORNECEDOR_CADASTRO_FAILURE,
    DELETE_FORNECEDOR_CADASTRO_PENDING,
    DELETE_FORNECEDOR_CADASTRO_SUCCESS,
    DELETE_FORNECEDOR_CADASTRO_FAILURE,
    CREATE_FORNECEDOR_CADASTRO_PENDING,
    CREATE_FORNECEDOR_CADASTRO_SUCCESS,
    CREATE_FORNECEDOR_CADASTRO_FAILURE,
    NEW_FILTER_FORNECEDOR_CADASTRO_PENDING,
    NEW_FILTER_FORNECEDOR_CADASTRO_SUCCESS,
    NEW_FILTER_FORNECEDOR_CADASTRO_FAILURE,
    NEW_FILTER_NEXT_PAGE_FORNECEDOR_CADASTRO_PENDING,
    NEW_FILTER_NEXT_PAGE_FORNECEDOR_CADASTRO_SUCCESS,
    NEW_FILTER_NEXT_PAGE_FORNECEDOR_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = {
  list: null,
  loading: false,
  filter: {
    rows: CONST_ROWS_PER_PAGE,
    page: 0,
    where: '',
  },
};


function fornecedorCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_FORNECEDOR_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_FORNECEDOR_CADASTRO_PENDING:
        case FIND_FORNECEDOR_CADASTRO_PENDING:
        case DELETE_FORNECEDOR_CADASTRO_PENDING:
        case CREATE_FORNECEDOR_CADASTRO_PENDING:
        case TABLE_FORNECEDOR_CADASTRO_PENDING:
        case NEW_FILTER_FORNECEDOR_CADASTRO_PENDING:
        case NEW_FILTER_NEXT_PAGE_FORNECEDOR_CADASTRO_PENDING:    
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_FORNECEDOR_CADASTRO_RAPIDO:
        case CANCEL_FORNECEDOR_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_FORNECEDOR_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_FORNECEDOR_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_FORNECEDOR_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_FORNECEDOR_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_FORNECEDOR_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_FORNECEDOR_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_FORNECEDOR_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_FORNECEDOR_CADASTRO_SUCCESS:
        case CREATE_FORNECEDOR_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_FORNECEDOR_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_FORNECEDOR_CADASTRO_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_FORNECEDOR_CADASTRO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_FORNECEDOR_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_FORNECEDOR_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { fornecedorCadastroReducer };